module.exports = __webpack_public_path__ + "static/img/partnership.93aafa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/tiles/partnership.png
// module id = pdV1
// module chunks = 1